export class Login {
  id: number;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  token: string;
}
export class User {
  id: number;
  user: string;
  role: string;
}
export enum Role {
  User = 'EmpleadoEmpresa',
  Admin = 'AdministradorEmpresa',
  Master = 'MasterWeb',
  Customer = 'CustomerEmpresa',
  werehouse = 'WarehouseEmpresa',
}
export class Response {
  Response: string;
}
export class responses {
  responses: string;
}
export class PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}
export class ResponseUSer {
  company: string;
  useremail: string;
  rol: string;
  token: string;
  name: string;
  id: string;
  companyIdWh: string;
  whId: string;
  customerId: string;
}
export interface RequestNewParking {
  idParking: number;
  latitudParking: number;
  longitudParking: number;
  spaceParking: number;
  addressParking: string;
  descriptionParking: string;
  typeService: string;
  systemDate: Date;
  userInsert: string;
}

export interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

export interface Location {
  lat: number;
  lng: number;
}

export interface Northeast {
  lat: number;
  lng: number;
}

export interface Southwest {
  lat: number;
  lng: number;
}

export interface Viewport {
  northeast: Northeast;
  southwest: Southwest;
}

export interface Geometry {
  location: Location;
  location_type: string;
  viewport: Viewport;
}

export interface PlusCode {
  compound_code: string;
  global_code: string;
}

export interface Result {
  address_components: AddressComponent[];
  formatted_address: string;
  geometry: Geometry;
  place_id: string;
  plus_code: PlusCode;
  types: string[];
}

export interface ReponseGoogle {
  results: Result[];
  status: string;
}

export interface IdParkingNavigation {
  idParking: number;
  latitudParking: number;
  longitudParking: number;
  spaceParking: number;
  addressParking: string;
  descriptionParking: string;
  typeService: string;
  systemDate: Date;
  userInsert: string;
}

export interface NewFeaturesParking {
  idFeatures: number;
  idParking: number;
  featureParking: string;
  systemDate: Date;
  userInsert: string;
  idParkingNavigation: IdParkingNavigation;
}
export interface item {
  id: number;
  title: string;
}
export interface itemPrices {
  Price: number;
  TypePrice: string;
  id: number;
}
export interface Price {
  priceParking: string;
  priceType: string;
}

export interface RequestPrices {
  idParking: number;
  prices: Price[];
  systemDate: Date;
  userInsert: string;
}
export interface ResponseSearchLocation {
  idParking: number;
  latitudParking: number;
  longitudParking: number;
  spaceParking: number;
  addressParking: string;
  descriptionParking: string;
  typeService: string;
  img: string;
}
export interface RequestSearchLocation {
  latitud: string;
  longitud: string;
}

export interface Info {
  idParking: number;
  latitudParking: number;
  longitudParking: number;
  spaceParking: number;
  addressParking: string;
  descriptionParking: string;
  typeService: string;
}

export interface Feature {
  idFeatures: number;
  featureParking: string;
}

export interface PricesParkin {
  IdPrice: number;
  priceParking1: string;
  priceType: string;
}

export interface Img {
  idSave: number;
  idParking: number;
  pathFile: string;
}

export interface ResponseInforParking {
  info: Info[];
  features: Feature[];
  pricesParkin: PricesParkin[];
  img: Img[];
}

export interface ResponseSearchResult {
  myLocation: ResponseSearchLocation[];
  alternative: ResponseSearchLocation[];
}
export interface idParkins {
  idPrices: number;
}
export interface RequestPay {
  firstname: string;
  lastname: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  amount: string;
  ccnumber: string;
  ccexp: string;
  cvv: string;
  idParking: string;
  idPrices: idParkins[];
  Company: string;
  email: string;
  SpacesSelect: string;
  inicio: string;
  Fin: string;
}
export interface MapArrr {
  id: number;
  Fila: string;
  identificacion: string;
  tipo: string;
}
export interface RequestAdd {
  fila: string;
  identificacion: string;
  tipo: string;
}

export interface RequestAddSapcesParking {
  idparking: string;
  user: string;
  requestAdd: RequestAdd[];
}
export interface Espacio {
  idmap: string;
  idparking: string;
  fila: string;
  identificacion: string;
  tipo: string;
  estado: string;
  fecha: string;
  users: string;
}

export interface ResponseReportes {
  fila: string;
  espacios: Espacio[];
}

export interface jsons {
  elemeto: string;
  valor: string;
}
export interface ResponseContent {
  values: string;
  Label: string;
}
export interface ResponseCompras {
  folio: string;
  idparkin: string;
  cantidad: string;
  inicio: string;
  fin: string;
  servicio: string;
  usuario: string;
  foliopago: string;
  folioParking: string;
  foliosServicio: string;
  jsonPago: jsons[];
  fechaPago: string;
  usuarioPago: string;
}
export interface JsonPago {
  elemeto: string;
  valor: string;
}

export interface ReponseMisCompras {
  folio: string;
  idparkin: string;
  cantidad: string;
  inicio: string;
  fin: string;
  servicio: string;
  usuario: string;
  foliospacio: string;
  jsonPago: JsonPago[];
  fechaPago: string;
  usuarioPago: string;
}
export interface RequestReserva {
  idParking: string;
  idMap: string;
  tipoPago: string;
  monto: string;
  inicio: string;
  fin: string;
  user: string;
  company: string;
}
export interface RequestEstado {
  idmap: string;
  estado: string;
}
export interface RequestBodegasAlta {
  company_id: string;
  titulo_bodega: string;
  direccion_bodega: string;
  telefono_bodega: string;
  email_bodega: string;
  users: string;
  descripciones: string;
  latitud: number;
  longitud: number;
  space: number;
}
export interface Img {
  patch: string;
}

export interface ResponseViewBodegas {
  id_bodega: string;
  company_id: string;
  titulo_bodega: string;
  direccion_bodega: string;
  telefono_bodega: string;
  email_bodega: string;
  estado_bodega: string;
  descripcion: string;
  longitud_bodega: string;
  lagitud_bodega: string;
  espacios_bodega: string;
  img: Img[];
}
export interface RequestViewBodegas {
  tipo: string;
  company: string;
  latitud: number;
  longitud: number;
}

export interface Imagene {
  id_save: number;
  path_file: string;
  system_date: Date;
  user_insert: string;
}

export interface Precio {
  id_price: number;
  price_parking: string;
  price_type: string;
  system_date: Date;
  user_insert: string;
}

export interface Caracteristica {
  id_features: number;
  feature_parking: string;
}

export interface Identificacione {
  id_map: number;
  fila_map: string;
  identificacion_map: string;
  tipo_map: string;
  estado_map: string;
  fecha_sistema: Date;
  users_map: string;
}

export interface Informacion {
  imagenes: Imagene[];
  precios: Precio[];
  caracteristicas: Caracteristica[];
  identificaciones: Identificacione[];
}

export interface ResponseInfoParkingCompany {
  idparking: number;
  latitud: number;
  longitud: number;
  espacios: number;
  direccion: string;
  descripcion: string;
  tipo: string;
  fecha: Date;
  usuario: string;
  Informacion: Informacion[];
}
export interface RequestUpdateIdentificacionEstacionamiento {
  idParking: number;
  idMap: number;
  fila: string;
  identificacion: string;
  tipo: string;
}
export interface ResponseViewContenedores {
  position: number;
  coun: string;
  steamship: string;
  pu: string;
  loaded: string;
  description: string;
  container: string;
  fecha: Date;
  telefono: string;
  email: string;
  direccion: string;
  chasis: string;
}
export interface ViewMapContenedor {
  origen: google.maps.LatLngLiteral;
  destino: google.maps.LatLngLiteral;
}

export interface datum {
  coun: string;
  steamship: string;
  pu: string;
  loaded: string;
  description: string;
  container: string;
  fecha: string;
  telefono: string;
  email: string;
  direccion: string;
  chasis: string;
}

export interface RequestAddNewContenedor {
  company: string;
  user: string;
  data: datum[];
}
export interface Message {
  clientuniqueid: string;
  type: string;
  message: string;
  date: Date;
}
export interface RequestUsuariosActivos {
  id: number;
  email: string;
  idsignalr: string;
  agente: string;
  estatus: string;
  plataforma: string;
  ultimaves: Date;
  companyid: string;
}
export interface RequestConexionSignalR {
  plataforma: string;
  Useremail: string;
  companyId: string;
}
export interface ReconexionChat {
  plataforma: string;
  Useremail: string;
  companyId: string;
  ClientId:string;
}
export interface Chat {
  company_id: string;
  fecha_chat: Date;
  folio_chat: string;
  id_chat: number;
  id_usuario: number;
  mensaje_chat: string;
  tipo_chat: string;
}

export interface Registro {
  id_usuario: string;
  folio_chat: string;
  chat: Chat[];
}

export interface RequestChatsHistorico {
  usuario: string;
  registros: Registro[];
}
export interface ResponseLocalitation {
  id: number;
  Location: string;
  LocationLength: number;
  LocationWidth: number;
  LocationHeight: number;
  LocationTemperature: number;
  LowQuantity: number;
  LocationDescription: string;
  LocationType: string;
  Active: boolean;
}

export interface ResponseLocalitationNew {
  id: number;
  location: string;
  locationLength: number;
  locationWidth: number;
  locationHeight: number;
  locationTemperature: number;
  lowQuantity: number;
  locationDescription: string;
  locationType: string;
  active: boolean;
}
export interface ResponseUsersAdmin {
  id: number;
  ClientAccNum: string;
  Name: string;
  Last_Name: string;
  User_Address: string;
  City: string;
  User_State: string;
  Zip: string;
  Phone: string;
  Ext: string;
  Cell_Phone: string;
  Fax: string;
  Email: string;
  UserPassword: string;
  Active: boolean;
  AcceptedTOS?: boolean;
  AcceptedTOSDate?: Date;
  PictureLocation: string;
  IMSApp: string;
  tblAppThemeID: number;
  Date_Created: Date;
  tblAppThemeBGColor: string;
  tblAppThemeFontColor: string;
  tblAppThemeFontSize: string;
  tblAppThemeFontFamily: string;
}
export interface Arg {
  arg: string;
}

export interface ArgumentsExt {
  arg: string;
}

export interface NotifySignalR {
  clientId: number;
  method: string;
  arg: Arg[];
  argumentsExt: ArgumentsExt[];
}
export interface Lector {
  Resultado: any;
  modulo: string;
 
}
export interface ResponseSearchOrderWerehouse {
  id: number;
  ItemNumber: string;
  Description: string;
  Type: string;
  Location: string;
  Boxes: number;
  Pieces: number;
  Quantity: number;
  Needed: number;
}
export interface ResponsePekingOrderWerehouse {
  id: number;
  ItemNumber: string;
  Description: string;
  Type: string;
  Location: string;

}

export interface Chat {
  company_id: string;
  fecha_chat: Date;
  folio_chat: string;
  id_chat: number;
  id_usuario: number;
  mensaje_chat: string;
  tipo_chat: string;
}

export interface Registro {
  id_usuario: string;
  folio_chat: string;
  chat: Chat[];
}

export interface HubChatHistorico {
  usuario: string;
  registros: Registro[];
}
export interface RequestLlamadas {
  twilioId: number;
  id_agente?: number;
  name_agente: string;
  apellidos_agente: string;
  CallStatus: string;
  SequenceNumber: string;
  Called: string;
  From: string;
  To: string;
  ToState: string;
  CallerCountry: string;
  CallerState: string;
  ToZip: string;
  CallerZip: string;
  CalledZip: string;
  CallDuration: string;
  CalledCity: string;
  CallerCity: string;
  ParentCallSid: string;
  CalledVia: string;
  CallSid: string;
  CallbackSource: string;
  Timestamp: string;
  ForwardedFrom: string;
  fecha_request: string;
}
export interface ResponseMessageCall {
  id_message: number;
  from_message: string;
  to_message: string;
  body_message: string;
  reenviar_message: string;
  json_message: string;
  fecha_message: Date;
  estado_message: string;
}
export interface DialogData {
  //ship to
  Company: string;
  Address: string;
  Address1: string;
  City: string;
  State: string;
  Zip: string;
  Phone: string;
  Fax: string;
  Cname: string;
  Cphone: string;
  Cemail: string;

  //Carrier instructions
  Account: string;
  BOL: string;
  Tracking: string;
  CarrierName: string;
  SCAC: string;
  Billing: string;
  ServiceType: string;
  Seal: string;
  Door: string;
  Trailer: string;
  PickupDate: string;
  loadnumber: string;
  Sealnumber: string;
  COD: string;
  warehouseInstructions: string;
  carrierInstructions: string;

  //Order Items
  Quantity: Number;
  Receiving: Number;
  Pallet: Number;
  Misc: string;

  // Order Charges
  Price: Number;
  Amount: Number;
  QuantityOC: Number;
  SelectSearch: [];
  PlaceOrderRegistro: any;

  tbId: string;

  SelectCapacity: string;
}

export interface ResponseDetallesDeletePlaceOrder {
  idOrder: number;
  idOrderItems: number;
  CantidadOrderItems: number;
  productNumber: string;
  productDescription: string;
  ReceivingProductsItemsID: number;
  ReceivingProductsLocationID: number;
  idReceiving: number;
  receivingCantidad: number;
  totalReceiving: number;
  locationId: number;
  Localizacion: string;
  cantidadLocation: number;
  totalLocation: number;
}

export interface ResponseTipoDocumentoPlaceOrder {
  key: number;
  value: string;
}

export interface mensajesArrayExcel{
  celda:string;
  itemname:string;
  mensajes:string;

}
export interface RRequesttypeLocations {
  key: number;
  value: string;
  disponible:Boolean;
}
export interface ResponseReceivingChanges {
  Id: number;
  tblReceivingID: number;
  tblCompanyChargesID?: any;
  tblInvoiceListDescription: string;
  ChargeDescription: string;
  UnitPrice: number;
  Quantity: number;
  Total: number;
  QBIntegrated: boolean;
}
export interface ResponseReceivingChangesAccounting {
  Id: number;
  tblReceivingID: number;
  tblCompanyChargesID?: any;
  tblInvoiceListID: number;
  tblInvoiceListDescription: string;
  ChargeDescription: string;
  UnitPrice: number;
  Quantity: number;
  Total: number;
  QBIntegrated: boolean;
  tblChartOfAccountID:number;
}
export interface ResponseCompanyCharges {
  Id: number;
  CompanyID: number;
  Accessorial: string;
  ChargeAmount: number;
  Date_Created: Date;
  Active: boolean;
  tblInvoiceListID: number;
  QBIntegrated: boolean;
  QBIntegratedDate: Date;
  QBIntegratedStatus: boolean;
  QBListID?: any;
  QBChartOfAccount?: any;
}
export interface ResponseCompanyChargesAccounting {
  Id: number;
  CompanyID: number;
  Accessorial: string;
  ChargeAmount: number;
  Date_Created: Date;
  Active: boolean;
  tblInvoiceListID: number;
  QBIntegrated: boolean;
  QBIntegratedDate: Date;
  QBIntegratedStatus: boolean;
  QBListID?: any;
  QBChartOfAccount?: any;
  tblChartOfAccount: number;
}
export interface ResponseFilesUrl{
  file: string;
  fileurl: string;
}
export interface ResponseCustomerCharges {
  id: number;
  tblCustomerID: number;
  Company_Name: string;
  tblCompanyChargesID: number;
  Amount: number;
  Active: boolean;
}
export interface ResponseCustomerChargesAccounting {
  id: number;
  tblCustomerID: number;
  Company_Name: string;
  tblCompanyChargesID: number;
  Amount: number;
  Active: boolean;
}
export interface RequestCustomerNewOrEdit {
  tblCompanyID: number;
  company_Name: string;
  company_Address: string;
  company_Address1: string;
  company_City: string;
  company_State: string;
  company_Zip: string;
  company_Logo: string;
  company_Phone: string;
  company_Fax: string;
  company_Email: string;
  company_Website: string;
  company_UPS_Account: string;
  company_FedEx_Account: string;
  company_PaymentTerms: string;
  contactName: string;
  contactLastName: string;
  contactEmail: string;
  contactPhone: string;
  contactFax: string;
  apContactName: string;
  apContactLastName: string;
  apContactEmail: string;
  apContactPhone: string;
  apContactFax: string;
  active: boolean;
  billingType: string;
  storageFreeDays: number;
  tipo: number;
}

export interface ResponseContact {
	id: number;
	tblCompanyID: number;
	CompanyName: string;
	Address: string;
	Address1: string;
	City: string;
	State: string;
	ZipCode: string;
	Phone: string;
	Fax: string;
	ContactName: string;
	ContactPhone: string;
	ContactEmail: string;
	DateCreated: Date;
}
export interface RequestLogin3plapp {
  accounting: Accounting
  wms: Wms
}

export interface Accounting {
  useremail: string
  token: string
  name: string
  id: number
  appThemeBGColor: string
  appThemeFontColor: string
  appThemeFontSize: string
  appThemeFontFamily: string
  dateCreated: string
  tblCompanyId: number
  public: boolean
}

export interface Wms {
  id: number
  whId: number
  companyNameWh: string
  companyIdWh: number
  name: string
  lastName: string
  useremail: string
  customerIdWh: string
  rolWh: string
  token:string
}

export interface ResponseInvoiceHeader {
  Id: number
  tblCompanyId: number
  companyName: string
  address: string
  address1: string
  city: string
  state: string
  zipCode: string
  phone: string
  fax: string
  email: string
  website: string
  logo: string
  invoicePrefix: string
  invoiceNumber: number
  factorCompany: string
  invoiceTemplateName: string
  tblAccountingId: number
}
export interface ResponseInvoiceItemsList {
  id: number
  itemName: string
  itemDescription: string
  itemPrice: number
  active: boolean
  tblChartOfAccountId: number
  accountName: string
}


